/**
 * Enum Tổng hợp dự toán
 * NMDUC1 6.7.2022
 */
export default {
  ReceiptBudget: 152,
  ReceiptActivity342: 331,
  ReceiptActivity343: 334,
  ReceiptActivity344: 337,
  PaymentBudget: 150,
  PaymentActivity342: 322,
  PaymentActivity343: 325,
  PaymentActivity344: 328,
};
